module.exports = __webpack_public_path__ + "static/flags/EC-c77c0e87151f1d464fc3d33e45fb92d3.gif";